import { Controller } from "@hotwired/stimulus"

// A Merges card offered as one release's options: Merge as options' confirm
// names the options it will make, as the Version boxes stand (a name
// edited, a figure unticked).
export default class extends Controller {
  static targets = ["name", "button"]
  static values = { keep: String }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasButtonTarget) return
    const ticked = this.nameTargets.filter(input => {
      const tick = this.element.querySelector(`input[name='other_ids[]'][value='${input.dataset.figureId}']`)
      return !tick || tick.type === "hidden" || tick.checked // a pair's other is always merged: no tick
    })
    const names = ticked.map(input => input.value.trim() || `no option (${input.dataset.figureName})`)
    this.buttonTarget.dataset.turboConfirm = `Merge into ${this.keepValue}, as these options?\n\n${names.map(name => `• ${name}`).join("\n")}`
  }
}
